import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { filtrer, donneFiltresPourEnfant } from '@/services/general/listeFilter';
import faceSelectedInitialise from '@/services/catalogue/faceSelectedInitializer';
import gestionErreur from '@/services/general/gestionErreur';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import { DUREE_PERIODE_AN_DEFAUT } from '@/components/creationOpportunite/configuration/dateFiltreConf';
import GetListeElementUniqueParPropriete from '@/services/general/listeFilterDynamique';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import customArraySort from '@/services/general/customArraySort';
import { ZOOM_DEFAULT_LC, RAYON_DEFAULT, PANNEAUX_FROM_VENTES_LC, ISOCHRONE_DEFAULT, TYPE_LAYER_EMPTY } from '@/configuration/carteConf';
import { affectationFaceLc } from '@/configuration/affectationFaceLcFilter';
import { panneauLcExtensionInitializer } from '@/services/panier/extensionInitializer';
import {
  iconColorGetter,
  TAILLE_ICON_PETIT,
} from '@/services/general/iconColorGetter';
import {
  browsePanneaux,
  getPanneauxPoints,
  getPlanningPdf,
  nogeo,
  noattachment,
} from '../../api/PanneauxLc/index';
import * as types from './venteFacesLc-mutation-type';
import * as typesPanier from './panier-mutation-type';
import * as allTypes from '../mutation-type';
import { CLASS_NIVEAU_DISPONIBILITE } from '../../components/creationOpportunite/configuration/DisponibiliteConf';


function initialState() {
  return {
    dateStart: moment().toDate(),
    dateEnd: moment().add(DUREE_PERIODE_AN_DEFAUT, 'y').subtract(1, 'd').toDate(),
    disponibilite: [],
    format: [],
    address: null,
    showPanneaux: false,
    panneauxLc: [],
    panneauxLcWithFilter: [],
    markers: [],
    rayon: RAYON_DEFAULT,
    isochrone: ISOCHRONE_DEFAULT,
    typeLayerGeoMarketing: TYPE_LAYER_EMPTY,
    filterChanged: true,
    selectedMarker: '',
    filtres: {},
    criterePlanning: {},
    filtresDynamiques: [],
    affichageCercle: false,
    zoomCarto: ZOOM_DEFAULT_LC,
    selectedFiltreDynamique: FILTRE_DYNAMIQUE_VIDE,
    showPanneauxSelectionne: false,
    proposableLc: '1',
    pointsAddress: [],
    tabFiltreDispo: [],
    affectationFaceLcFilter: cloneDeep(affectationFaceLc),
    panneauNoGeo: [],
    panneauxNoAttach: [],
    searchByCode: false,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_SEARCH_BY_CODE](state, searchByCode) {
    state.searchByCode = searchByCode;
  },
  [types.SET_DATE_START](state, date) {
    state.dateStart = date;
  },
  [types.SET_DATE_END](state, date) {
    state.dateEnd = date;
  },
  [types.SET_DISPONIBILITE](state, disponibilite) {
    state.disponibilite = disponibilite;
  },
  [types.SET_FILTER_CHANGED](state) {
    state.filterChanged = !state.filterChanged;
  },
  [types.SET_FILTER_FORMAT](state, format) {
    state.format = format;
  },
  [types.SET_FILTER_ADDRESS](state, address) {
    state.address = address;
  },
  [types.SET_PANNEAUX_LC](state, panneauxLc) {
    state.panneauxLc = panneauxLc;
  },
  [types.SET_CRITERE_PLANNING_LC](state, critere) {
    state.criterePlanning = critere;
  },
  [types.SET_PANNEAUXLC_WITH_FILTER](state, panneauxLc) {
    state.panneauxLcWithFilter = panneauxLc;
  },
  [types.SET_MARKER](state, markers) {
    state.markers = markers;
  },
  [types.SET_FILTER_RAYON](state, rayon) {
    state.rayon = rayon;
  },
  [types.SET_ISOCHRONE](state, isochrone) {
    state.isochrone = isochrone;
  },
  [types.SET_TYPE_LAYER_GEO_MARKETING](state, typeLayerGeoMarketing) {
    state.typeLayerGeoMarketing = typeLayerGeoMarketing;
  },
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_SELECTED_MARKER](state, marker) {
    state.selectedMarker = marker;
  },
  [types.SET_SHOW_PANNEAUX](state, showPanneaux) {
    state.showPanneaux = showPanneaux;
  },
  [types.ADD_FILTER_PROPERTY](state, { property, valueProperty }) {
    state.filtres[property] = valueProperty;
    state.tabFiltreDispo = Object.values(state.filtres).map(el => el.valeur);
  },
  [types.REMOVE_FILTER_PROPERTY](state, property) {
    state.filtres[property] = {};
    state.filtresDynamiques.forEach((filtreDynamique) => {
      if (filtreDynamique.id === property) {
        state.filtresDynamiques.splice(state.filtresDynamiques.indexOf(filtreDynamique), 1);
      }
    });
    state.selectedFiltreDynamique = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.REMOVE_FILTER](state) {
    state.filtres = {};
    state.filtresDynamiques = [];
    state.selectedFiltreDynamique = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.ADD_FILTER_DYNAMIQUE](state, value) {
    const filtre = state.filtresDynamiques.find((el) => { return el.id === value.id; });
    if (filtre) {
      state.filtresDynamiques.splice(state.filtresDynamiques.indexOf(filtre), 1, value);
    } else {
      state.filtresDynamiques.unshift(value);
    }
  },
  [types.SET_AFFICHAGE_CERCLE](state, affichageCercle) {
    state.affichageCercle = affichageCercle;
  },
  [types.SET_ZOOM_CARTO](state, zoomCarto) {
    state.zoomCarto = zoomCarto;
  },
  [types.SELECT_FILTRE_DYNAMIQUE](state, filtre) {
    state.selectedFiltreDynamique = filtre;
  },
  [types.TRIE_PANNEAUX](state) {
    state.panneauxLcWithFilter.sort(customArraySort(['ville', 'code']));
  },
  [types.SET_SHOW_PANNEAUX_SELECTIONNE](state, showPanneauxSelectionne) {
    state.showPanneauxSelectionne = showPanneauxSelectionne;
  },
  [types.SET_PROPOSABLE_LC](state, proposableLc) {
    state.proposableLc = proposableLc;
  },
  [types.SET_POINTS_ADDRESS](state, pointsAddress) {
    state.pointsAddress = pointsAddress;
  },
  [types.SET_AFFECTATION_FACE_LC_FILTER](state, value) {
    state.affectationFaceLcFilter = value;
  },
  [types.SET_PANNEAUX_NOGEO](state, values) {
    state.panneauNoGeo = values;
  },
  [types.SET_PANNEAUX_NOATTACH](state, values) {
    state.panneauxNoAttach = values;
  },
};

const actions = {
  gestionPanneauxLC: async ({ getters, rootGetters, commit, dispatch }, payload) => {
    if (payload.valid) {
      try {
        const dateStart = moment(getters.dateStart).format('YYYYMMDD');
        const dateEnd = moment(getters.dateEnd).format('YYYYMMDD');
        commit(types.SET_SHOW_PANNEAUX, false);
        const responseAllPoint = await getPanneauxPoints(getters.pointsAddress, getters.rayon,
          dateStart, dateEnd, getters.proposableLc, payload.codeFace);
        let response = [];
        let tabAll = [];
        if (getters.address !== null) {
          response = await browsePanneaux(getters.address, getters.rayon, dateStart, dateEnd,
            getters.proposableLc, payload.codeFace);
          if (response.data !== undefined) {
            response.data.forEach(el => {
              el.pointAddress = {
                icon: iconColorGetter('#000000', TAILLE_ICON_PETIT),
                coordonnees: getters.address,
              };
            });
            tabAll = response.data.concat(responseAllPoint.map(el => el.data).flat());
          }
        } else {
          response = await browsePanneaux({ lat: 0.00, lng: 0.00 },
            getters.rayon, dateStart, dateEnd,
            getters.proposableLc, payload.codeFace);
          if (response.data !== undefined) {
            response.data.forEach(el => {
              el.pointAddress = {
                icon: iconColorGetter('#000000', TAILLE_ICON_PETIT),
                coordonnees: { lat: el.latitude, lng: el.longitude },
              };
            });
            tabAll = response.data.concat(responseAllPoint.map(el => el.data).flat());
            if (tabAll.length > 0) {
              commit('SET_FILTER_ADDRESS', { lat: tabAll[0].latitude, lng: tabAll[0].longitude });
            }
          }
        }
        payload.panneauxLcPanier.forEach((selectedItem) => {
          const panneau = tabAll.find((el) => {
            return el.num === selectedItem.num;
          });
          if (panneau) {
            panneau.selected = true;
            faceSelectedInitialise(panneau.faces, payload.panneauxLcPanier);
          } else {
            tabAll.push(selectedItem);
          }
        });
        tabAll.forEach((panneau) => {
          panneau.codeFaces = '';
          if (panneau.faces && panneau.faces.length > 0) {
            panneau.codeFaces = panneau.faces.map((el) => el.facCode).reduce((accumulator, currentValue) => accumulator + ', ' + currentValue);
          }
        });
        // On retrie la liste pour mettre la sélection en premier
        commit(types.SET_PANNEAUX_LC, tabAll);
        commit(types.SET_PANNEAUXLC_WITH_FILTER, getters.panneauxLc);
        dispatch('gestionDisponibilite');
        dispatch('gestionFiltres');
        commit(types.TRIE_PANNEAUX, getters.panneauxLcWithFilter);
        const afficherAzimut = rootGetters['user/afficherAzimut'];
        const markers = fromTypeToMarkers(PANNEAUX_FROM_VENTES_LC,
          getters.panneauxLcWithFilter, afficherAzimut);
        commit(types.SET_MARKER, markers);
        dispatch('reloadFiltreDynamique');
        dispatch('changementDateDebutPlanningLc',
          {
            debut: moment(getters.dateStart),
            nombreMois: 12,
          },
        );
        commit(types.SET_SHOW_PANNEAUX, true);
      } catch (e) {
        gestionErreur('Erreur lors de la récupération des panneaux LC', e);
        throw (e.code);
      }
    } else {
      commit(types.SET_PANNEAUX_LC, '');
      commit(types.SET_MARKER, '');
      commit(types.SET_SHOW_PANNEAUX, false);
    }
  },
  changementDateDebutPlanningLc: ({ getters, commit }, payload) => {
    let newStartDate = payload.debut;
    if (!newStartDate.isValid()) {
      newStartDate = moment();
    }
    newStartDate.startOf('month');
    const newEndDate = newStartDate.clone().add(payload.nombreMois - 1, 'M').endOf('month');
    const newDuration = newEndDate.diff(newStartDate, 'days') + 1;
    const critere = {};
    critere.selectedDateStart = moment(getters.dateStart);
    critere.selectedDateEnd = moment(getters.dateEnd);
    critere.months = payload.nombreMois;
    critere.dateStart = newStartDate;
    critere.dateEnd = newEndDate;
    critere.days = newDuration;
    commit(types.SET_CRITERE_PLANNING_LC, critere);
  },
  gestionDisponibilite: ({ getters, commit }) => {
    const value = getters.panneauxLc.map((panneau) => {
      panneau.dispoClass = CLASS_NIVEAU_DISPONIBILITE[panneau.niveauDisponibilite];
      return panneau;
    });
    commit(types.SET_PANNEAUX_LC, value);
  },
  gestionFiltres: ({ getters, rootGetters, commit }) => {
    commit(types.SET_FILTER_CHANGED);
    const azimut = rootGetters['user/afficherAzimut'];
    const panneauxLcWithFilter = filtrer(getters.panneauxLc, getters.filtres);
    panneauxLcWithFilter.forEach((el) => {
      const filtreDispo = donneFiltresPourEnfant(getters.filtres);
      el.faces = filtrer(el.faces, filtreDispo);
    });
    const dataFilter = panneauxLcWithFilter.filter(panneau => {
      const affLCFaces = panneau.faces.map(el => el.affectations).flat();
      const affResFaces = panneau.faces.map(el => el.affectationsReseaux).flat();
      if (getters.affectationFaceLcFilter.length < 3) {
        const affLC = getters.affectationFaceLcFilter.map(aff => aff.value).includes(1);
        const affRes = getters.affectationFaceLcFilter.map(aff => aff.value).includes(2);
        const noAff = getters.affectationFaceLcFilter.map(aff => aff.value).includes(3);
        if (affLC && affRes) return affLCFaces.length > 0 || affResFaces.length > 0;
        if (affLC && noAff) {
          return affLCFaces.length > 0 || (affLCFaces.length === 0 && affResFaces.length === 0);
        }
        if (affRes && noAff) {
          return affResFaces.length > 0
            || (affLCFaces.length === 0 && affResFaces.length === 0);
        }
        if (affLC) return affLCFaces.length > 0 && affResFaces.length === 0;
        if (affRes) return affLCFaces.length === 0 && affResFaces.length > 0;
        if (noAff) return (affLCFaces.length === 0 && affResFaces.length === 0);
      }
      return true;
    });
    commit(types.SET_PANNEAUXLC_WITH_FILTER, dataFilter);
    commit(types.SET_MARKER, fromTypeToMarkers('panneauxFromVentesLC', getters.panneauxLcWithFilter, azimut));
    commit(types.SET_SELECTED_MARKER, '');
  },
  ajoutFiltresDynamiques: ({ getters, commit }, payload) => {
    if (!getters.filtresDynamiques.find((el) => { return el.id === payload.valueProperty.id; })) {
      const prop = payload.valueProperty;
      prop.valeur = (GetListeElementUniqueParPropriete(getters.panneauxLc,
        payload.valueProperty.id));
      commit(types.ADD_FILTER_DYNAMIQUE, prop);
    }
  },
  updateMarkerPanneau: ({ getters, rootGetters, commit }) => {
    const afficherAzimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_MARKER,
      fromTypeToMarkers(PANNEAUX_FROM_VENTES_LC, getters.panneauxLcWithFilter, afficherAzimut));
  },
  reloadFiltreDynamique: ({ getters, commit, dispatch }) => {
    getters.filtresDynamiques.forEach((filtre) => {
      const prop = filtre;
      const filtrePropChecked = filtre.valeur.filter((el) => { return el.checked === true; });
      prop.valeur = (GetListeElementUniqueParPropriete(getters.panneauxLc,
        filtre.id));
      prop.valeur.forEach((valeur) => {
        if (filtrePropChecked.find((el) => { return el.name === valeur.name; })) {
          valeur.checked = true;
        }
      });
      filtrePropChecked.forEach((valeur) => {
        if (!prop.valeur.find((el) => {
          return el.name === valeur.name;
        })) {
          prop.valeur.push(valeur);
        }
      });
      commit(types.ADD_FILTER_DYNAMIQUE, prop);
      if (filtrePropChecked.length > 0) {
        dispatch('gestionFiltres');
      }
    });
  },
  gestionPanier: async ({ getters, rootGetters, dispatch, commit }, payload) => {
    const panneaux = getters.panneauxLcWithFilter;
    const panneau = panneaux.find((el) => {
      return el.panNum === payload.face.panNum;
    });
    if (!panneau) {
      return;
    }
    const fac = panneau.faces.find((el) => { return el.facNum === payload.face.facNum; });
    if (fac) {
      fac.selected = !fac.selected;
      panneau.faces.forEach((el) => {
        if (el.selected || fac.selected) {
          panneau.selected = true;
        } else {
          panneau.selected = false;
        }
      });
    }
    commit(types.SET_PANNEAUXLC_WITH_FILTER, panneaux);
    const produit = rootGetters['panier/panneauxLcPanier'].find(produit =>
      produit.num === payload.face.panNum &&
      produit.extensionOpportunite.faceSelectionne.facNum === payload.face.facNum);
    if (produit && produit.extensionOpportunite.faceSelectionne.facNum === payload.face.facNum) {
      dispatch('suppressionDuPanier', produit);
    } else {
      await dispatch('ajoutAuPanier', {
        panneauLc: panneau,
        face: fac,
        dateDebut: getters.dateStart,
        dateFin: getters.dateEnd,
      });
    }
    dispatch('updateMarkerPanneau');
  },
  ajoutAuPanier: async ({ commit, dispatch, rootGetters }, payload) => {
    const panneauLcAAjouter = await panneauLcExtensionInitializer(
      Object.assign({}, payload.panneauLc),
      payload.face,
      payload.dateDebut,
      payload.dateFin,
    );
    panneauLcAAjouter.selected = false;
    const adresse = rootGetters['panier/adressePanier'];
    let adresseFaceLc = {};
    if (adresse) {
      adresseFaceLc = {
        lat: adresse.coordonnees.lat,
        lng: adresse.coordonnees.lng,
        nom: 'adresseFaceLc',
      };
    }
    commit('panier/' + typesPanier.ADD_PRODUIT_TYPE_PANNEAU, panneauLcAAjouter, { root: true });
    commit('panier/' + typesPanier.ADD_ADRESSES_PRODUITS, adresseFaceLc, { root: true });
    dispatch('panier/genererMarkerPanneauxLc', null, { root: true });
  },
  suppressionDuPanier: ({ commit, dispatch }, produit) => {
    commit('panier/' + typesPanier.REMOVE_PRODUIT_TYPE_PANNEAU, produit, { root: true });
    commit('panier/' + typesPanier.REMOVE_ADRESSES_PRODUITS, null, { root: true });
    dispatch('panier/removeReseauPersonnalise', { response: produit }, { root: true });
  },
  getPlanningPdf: async ({ getters, rootGetters }, panneauFilter) => {
    try {
      const dateStart = moment(getters.dateStart).format('YYYYMMDD');
      const dateEnd = moment(getters.dateEnd).format('YYYYMMDD');
      const user = rootGetters['user/userEmail'];
      const response = await getPlanningPdf(
        getters.address, getters.rayon,
        dateStart, dateEnd, getters.proposableLc,
        user, panneauFilter);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.data);
      const disposition = response.request.getResponseHeader('Content-Disposition');
      link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
      link.click();
    } catch (e) {
      gestionErreur('Erreur lors de la génération du planning PDF des panneaux LC', e);
    }
  },
  getPanneauxNoGeoNoAttach: async ({ commit }) => {
    const listePanNogeo = (await nogeo()).data;
    const listePanNoattachment = (await noattachment()).data;
    commit(types.SET_PANNEAUX_NOGEO, listePanNogeo);
    commit(types.SET_PANNEAUX_NOATTACH, listePanNoattachment);
  },
};

const getters = {
  searchByCode: (state) => {
    return state.searchByCode;
  },
  dateStart: (state) => {
    return state.dateStart;
  },
  dateEnd: (state) => {
    return state.dateEnd;
  },
  disponibilite: (state) => {
    return state.disponibilite;
  },
  disponibiliteAvailability: (state) => {
    return state.dateEnd && state.dateStart && state.address;
  },
  filterChanged: (state) => {
    return state.filterChanged;
  },
  format: (state) => {
    return state.format;
  },
  panels: (state) => {
    return state.panels;
  },
  address: (state) => {
    return state.address;
  },
  rayon: (state) => {
    return state.rayon;
  },
  isochrone: (state) => {
    return state.isochrone;
  },
  typeLayerGeoMarketing: (state) => {
    return state.typeLayerGeoMarketing;
  },
  panneauxLc: (state) => {
    return state.panneauxLc;
  },
  criterePlanning: (state) => {
    return state.criterePlanning;
  },
  panneauxLcIsSelected: (state) => (idPanneau) => {
    const panneau = state.panneauxLc.find((el) => { return el.num === idPanneau; });
    if (panneau) {
      return panneau.selected;
    }
    return false; // ne devrait jamais arriver
  },
  showPanneaux: (state) => {
    return state.showPanneaux;
  },
  markers: (state) => {
    return state.markers;
  },
  panneauxLcWithFilter: (state) => {
    return state.panneauxLcWithFilter;
  },
  selectedMarker: (state) => {
    return state.selectedMarker;
  },
  filtres: (state) => {
    return state.filtres;
  },
  filtresDynamiques: (state) => {
    return state.filtresDynamiques;
  },
  filtresDynamiquesSpe: (state) => (id) => {
    return state.filtresDynamiques.find((el) => { return el.id === id; });
  },
  affichageCercle: (state) => {
    return state.affichageCercle;
  },
  zoomCarto: (state) => {
    return state.zoomCarto;
  },
  selectedFiltreDynamique: (state) => {
    return state.selectedFiltreDynamique;
  },
  showPanneauxSelectionne: (state) => {
    return state.showPanneauxSelectionne;
  },
  proposableLc: (state) => {
    return state.proposableLc;
  },
  pointsAddress: (state) => {
    return state.pointsAddress.filter(el => el.coordonnees);
  },
  tabFiltreDispo: (state) => {
    return state.tabFiltreDispo;
  },
  affectationFaceLcFilter: (state) => {
    return state.affectationFaceLcFilter;
  },
  nbrPanNoGeo: (state) => {
    return state.panneauNoGeo.length;
  },
  nbrPanNoAttach: (state) => {
    return state.panneauxNoAttach.length;
  },
  panneauNoGeo: (state) => {
    return state.panneauNoGeo;
  },
  panneauxNoAttach: (state) => {
    return state.panneauxNoAttach;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/venteFacesLc.js